import {
  DialogTitle,
  DialogDescription,
  DialogHeader,
  DialogContent,
} from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { useGoogleLogin } from "@react-oauth/google";
import { useEffect, useState } from "react";
import { createUrl, post, setStoredJwt } from "../../network/AxiosInterceptor";
import { useToast } from "../../components/ui/use-toast";
import { Toaster } from "../../components/ui/toaster";
import { useUser } from "../../contextApi/userContext";

export const LoginContainerViewContent = ({ onDismissLoginInvoked }) => {
  const { toast } = useToast();
  const [googleAccessToken, setGoogleAccessToken] = useState(null);
  const [facebookAccessToken, setFacebookAccessToken] = useState(null);
  const [instaAccessToken, setInstaAccessToken] = useState(null);
  const userSetter = useUser();

  const startGoogleLoginFlow = useGoogleLogin({
    onSuccess: (codeResponse) => {
      setGoogleAccessToken(codeResponse.access_token);
    },
    onError: (error) => {
      console.log("Login Failed:", error);
      onDismissLoginInvoked();
      showToastOnLoginFailed();
    },
  });

  useEffect(() => {
    if (userSetter.user.role != "guest") {
      return;
    }
    // if (localStorage.getItem("refreshToken") && localStorage.getItem("refreshToken") != "undefined") {
    //   console.log('header 1',userSetter)
    //   try {
    //     post(createUrl('/api/authentication/refresh'), {
    //       headers: {
    //         Authorization: `Bearer ${localStorage.getItem("refreshToken")}`,
    //         Accept: "application/json",
    //       },
    //     }).then((response) => {
    //       if (response.data.message == "Access authorized") {
    //         const verifiedUser = {
    //           email: response.data.user.email,
    //           firstName: response.data.user.firstName,
    //           lastName: response.data.user.lastName,
    //           profilePic: response.data.user.profilePic,
    //           role: response.data.user.role? response.data.user.role: "user"
    //         }
    //         userSetter?.setUser(verifiedUser);
    //         setStoredJwt(response.data.accesstoken);
    //         localStorage.setItem("refreshToken", response.data.refreshToken);
    //       } else {
    //         localStorage.removeItem("accessToken")
    //         localStorage.removeItem("refreshToken");
    //       }

    //     }).catch((err)=>{
    //       localStorage.removeItem("accessToken")
    //       localStorage.removeItem("refreshToken");

    //     })
    //   } catch (e) {
    //     localStorage.removeItem("accessToken")
    //     localStorage.removeItem("refreshToken");
    //   }

    // } else {
    if (!googleAccessToken && !facebookAccessToken && !instaAccessToken) {
      return;
    }
    post(createUrl(`/api/authentication/signin`), {
      googleAccessToken: googleAccessToken,
    })
      .then((response) => {
        setStoredJwt(response.data.accesstoken);
        localStorage.setItem("refreshToken", response.data.refreshToken);
        // userSetter?.setUser({...response?.data?.user,role: response?.data?.user?.role ? response?.data?.user?.role: "user"});
        onDismissLoginInvoked();
        showToastOnLoginSuccess();
        window.location.reload();
      })
      .catch(function (error) {
        console.log(error);
        userSetter?.setUser({ role: "guest" });
        showToastOnLoginFailed();
        onDismissLoginInvoked();
      });
    // }
  }, [googleAccessToken, facebookAccessToken, instaAccessToken]);

  const startFacebookLoginFlow = useGoogleLogin({});

  const startInstaLoginFlow = useGoogleLogin({});

  const showToastOnLoginSuccess = () => {
    toast({
      title: "Exploro",
      description: "You are now logged-in",
    });
  };

  const showToastOnLoginFailed = () => {
    toast({
      title: "Exploro",
      description: "Login Failed",
      variant: "destructive",
    });
  };

  return (
    <DialogContent className="sm:max-w-[425px]">
      <DialogHeader>
        <DialogTitle>Login to Your Account</DialogTitle>
        <DialogDescription>
          Choose your preferred method to continue.
        </DialogDescription>
      </DialogHeader>
      <div className="grid gap-4 py-4">
        <Button
          className="flex items-center justify-center space-x-2 w-full bg-[#4285F4] text-white"
          onClick={startGoogleLoginFlow}
        >
          <ChromeIcon className="w-4 h-4" />
          <span>Login with Google</span>
        </Button>
        <Button
          className="flex items-center justify-center space-x-2 w-full bg-[#3b5998] text-white"
          onClick={startGoogleLoginFlow}
          // onClick={startFacebookLoginFlow}
        >
          <FacebookIcon className="w-4 h-4" />
          <span>Login with Facebook</span>
        </Button>
        <Button
          className="flex items-center justify-center space-x-2 w-full bg-[#E1306C] text-white"
          onClick={startGoogleLoginFlow}
          // onClick={startInstaLoginFlow}
        >
          <InstagramIcon className="w-4 h-4" />
          <span>Login with Instagram</span>
        </Button>
      </div>
      <Toaster />
    </DialogContent>
  );
};

function ChromeIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="4" />
      <line x1="21.17" x2="12" y1="8" y2="8" />
      <line x1="3.95" x2="8.54" y1="6.06" y2="14" />
      <line x1="10.88" x2="15.46" y1="21.94" y2="14" />
    </svg>
  );
}

function FacebookIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
    </svg>
  );
}

const InstagramIcon = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
    </svg>
  );
};
